import { render, staticRenderFns } from "./TreeComments.vue?vue&type=template&id=2e411e38"
import script from "./TreeComments.vue?vue&type=script&lang=js"
export * from "./TreeComments.vue?vue&type=script&lang=js"
import style0 from "./TreeComments.vue?vue&type=style&index=0&id=2e411e38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports